import { render, staticRenderFns } from "./BehavioralQnrIntroGetStarted.vue?vue&type=template&id=38a71b51&scoped=true&"
import script from "./BehavioralQnrIntroGetStarted.vue?vue&type=script&lang=js&"
export * from "./BehavioralQnrIntroGetStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a71b51",
  null
  
)

export default component.exports